import React from 'react';

import './ProgressControl.scss';

const ProgressControl = ({duration, current, min, max, onChange = () => {}}) => {
  if (max > duration) max = duration;
  if (min < 0) min = 0;
  const minPercent = min / duration;
  const maxPercent = max / duration;

  const handleClick = e => {
    const rect = e.target.getBoundingClientRect();
    const available = maxPercent - minPercent;
    const widthPx = rect.width / available;
    const offset = widthPx * minPercent;
    const leftPosition = e.clientX - rect.left;
    // Compute clicked timeline position (between 0 and 1)
    const clickedPosition = Math.max(((leftPosition + offset) * (maxPercent - minPercent)) / rect.width, 0);
    onChange(clickedPosition * duration);
  };

  const currentStyle = {
    width: `${(current / duration) * 100}%`,
  };

  const availableStyle = {
    left: `${(min / duration) * 100}%`,
    right: `${100 - (max / duration) * 100}%`,
  };

  return (
    <div className="progress-control container">
      <div className="available" style={availableStyle} />
      <div className="current" style={currentStyle} />
      <div className="clickable" style={availableStyle} onClick={handleClick} />
    </div>
  );
};

export default ProgressControl;
